import { useCustom } from "@refinedev/core";
import { InvoiceResponse } from "@/types";
import { useSession } from "hooks/useSession/";

interface UseSubscriptionInvoicesOptions {
  /** Set to false to fetch on demand via `getInvoices` instead of automatically. Defaults to true. */
  enabled?: boolean;
}

export function useSubscriptionInvoices({
  enabled = true,
}: UseSubscriptionInvoicesOptions = {}) {
  const { currentOrganization: organization } = useSession();

  const { data, isLoading, error, refetch } = useCustom<InvoiceResponse[]>({
    url: `api/organizations/${organization?.id}/invoices`,
    method: "get",
    queryOptions: {
      enabled: enabled && !!organization?.id,
    },
    // the invoices lookup can 404 for subscriptions with no billing history
    // (e.g. seeded/dev data) - fail quietly into the table's empty state
    errorNotification: false,
  });

  const getInvoices = async () => {
    const result = await refetch();
    return result.data?.data;
  };

  return {
    invoices: data?.data ?? [],
    isLoading,
    error,
    refetch,
    getInvoices,
  };
}
